import Vue from 'vue'
import VueRouter from 'vue-router'

import SessionStore from '@/stores/SessionStore'
import AlertStore from '@/stores/AlertStore'
import routes from '@/constants/routes'
import hasPermission from "../filters/hasPermission";

export const router = new VueRouter({
  routes
});

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
};

router.beforeEach((to, _from, next) => {
  const isLoggedIn = SessionStore.isAuthenticated();
  const isPublicPage = to.matched.some(record => record.meta.authenticationRequired === false);
  const hasRole = isPublicPage || to.matched.some(record => hasPermission(record.meta.allowedRoles));

  if (!isLoggedIn && !isPublicPage) {
    next({path: '/login'});
  } else if (isLoggedIn && !hasRole) {
    next({path: '/page-inaccessible'});
  } else {
    next();
  }
});

router.afterEach(() => {
  AlertStore.clearMsg();
});

export default router
